import React from 'react'
import Questions from './components/Questions/Questions'
import Category from './components/Category/Category'
import Subject from './components/Subject/Subject'
// import Trashed from './components/Trashed/Trashed'

function Question() {
  return (
    <div className="qbm-content">
      <div className="qbm-accordion-panel">
        <Subject />
        <Category />
        {/* <Trashed /> */}
      </div>

      <Questions/>
    </div>
  )
}

export default Question



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/Question/index.jsx